import get from 'lodash.get';
import { connect } from 'react-redux';

import { getUserName, getOngoingChat } from 'app/modules';
import EndMessage from 'presentation/components/EndMessage';
import replaceUserName from 'lib/replaceUserName.js';
import { EndedReason } from 'enums/session';

export const mapStateToProps = state => {
  return {
    message: composeEndMessage(get(state, 'session.endedReason'), state),
  };
};

export function composeEndMessage(endedReason, state) {
  const userName = getUserName(state);
  switch (endedReason) {
    case EndedReason.AGENT_ENDED:
      return replaceUserName(userName, getOngoingChat(state).endMessageAgentEnded);

    case EndedReason.TIME_EXPIRED:
      return replaceUserName(userName, getOngoingChat(state).endMessageTimeExpired);

    case EndedReason.CONSUMER_NO_REPLY:
      return replaceUserName(userName, getOngoingChat(state).endMessageConsumerNoReply);

    case EndedReason.NEW_SESSION_STARTED:
      return replaceUserName(userName, getOngoingChat(state).endMessageNewSessionStarted);

    default:
      throw new Error('unknown ended chat reason!');
  }
}

const EndMessageContainer = connect(mapStateToProps)(EndMessage);

export default EndMessageContainer;
